import { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "./menuActions";
import { getCombos } from "../../Combo/comboActions";
import appConfigFile from "../../../../app-config";
import {
  PICKUP,
  DROPOFF,
  DELIVERY,
} from "../../OrderSetting/orderSettingTypes";

const GetMenuContainer = ({
  getMenu,
  getCombos,
  requestingGetMenu,
  isRequestingGetComboList,
  orderSettingReducer,
  locations,
  currentLocation,
}) => {
  const {
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
  } = orderSettingReducer;
  
  const getMenuProducts = useCallback(() => {
    const id =
      interOrderType === PICKUP && interPickUpDetails
        ? interPickUpDetails.id
        : interOrderType === DELIVERY && interDeliveryDetails && interDeliveryDetails.deliveryBusiness
        ? interDeliveryDetails.deliveryBusiness.id
        : interOrderType === DROPOFF && interDropOffDetails
        ? interDropOffDetails.id
        : null;
    if (id) {
      getMenu(id, interOrderType);

      if (appConfigFile.isComboEnabled) {
        getCombos(id);
      }
    }
  }, [interPickUpDetails, interDeliveryDetails, interDropOffDetails]);

  useEffect(() => {
    getMenuProducts();
  }, [getMenuProducts]);

  return null;
};

const mapStateToProps = (state) => ({
  requestingGetMenu: state.menuReducer.requestingGetMenu,
  orderType: state.menuReducer.orderType,
  isRequestingGetComboList: state.comboReducer.isRequestingGetComboList,
  currentLocation: state.locationsReducer.currentLocation,
  locations: state.locationsReducer.locations,
  orderSettingReducer: state.orderSettingReducer,
});

export default connect(mapStateToProps, { ...actions, getCombos })(
  GetMenuContainer
);
